<div class="th-menulevel">
  <div
    class="ir-btn ir-btn--big"
    [ngClass]="isVisible('general') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'general')"
  >
    <i *ngIf="isVisible('general')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.general' | translate }}</span>
  </div>
  <div
    class="ir-btn ir-btn--big"
    [ngClass]="isVisible('inspections') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'inspections')"
  >
    <i *ngIf="isVisible('inspections')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.inspections' | translate }}</span>
  </div>
  <div
    class="ir-btn ir-btn--big"
    [ngClass]="isVisible('plugins') ? 'th-btn-action' : 'th-btn-menulevel'"
    (click)="showGroup($event, 'plugins')"
  >
    <i *ngIf="isVisible('plugins')" class="material-icons ir-icon--left">keyboard_arrow_left</i>
    <span>{{ 'menus.plugins' | translate }}</span>
  </div>
  <div class="th-menulevel--area">
    <div class="th-menulevel--areacontent">
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(1)">
        <span>{{ 'menus.information' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(2)">
        <span>{{ 'menus.properties' | translate }}</span>
      </div>
      <div *ngIf="isVisible('general')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(10)">
        <span>{{ 'menus.inputLanguage' | translate }}</span>
      </div>
      <div
        *ngIf="isVisible('general')"
        [permissions]="[['visible', 'host']]"
        class="ir-btn ir-btn--area th-btn-menusublevel"
        (click)="selectMenu(3)"
      >
        <span>{{ 'menus.edit-json' | translate }}</span>
      </div>
      <div
        *ngIf="isVisible('general')"
        [permissions]="[['visible', 'inspection.delete', inspection]]"
        class="ir-btn ir-btn--area th-btn-remove"
        (click)="selectMenu(4)"
      >
        <span>{{ 'menus.delete' | translate }}</span>
      </div>
      <div *ngIf="isVisible('inspections')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(5)">
        <span>{{ 'menus.create-pre-installation' | translate }}</span>
      </div>
      <div *ngIf="isVisible('inspections')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(6)">
        <span>{{ 'menus.create-installation' | translate }}</span>
      </div>
      <div *ngIf="isVisible('inspections')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(7)">
        <span>{{ 'menus.create-instruction' | translate }}</span>
      </div>
      <div *ngIf="isVisible('plugins')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(8)">
        <span>{{ 'menus.add' | translate }} {{ 'menus.plugin' | translate }}</span>
      </div>
      <div *ngIf="isVisible('plugins')" class="ir-btn ir-btn--area th-btn-menusublevel" (click)="selectMenu(9)">
        <span>{{ 'menus.order' | translate }} {{ 'menus.plugins' | translate }}</span>
      </div>
    </div>
  </div>
</div>
